<template>
  <i
    class="fa"
    :class="{
      'fa-chevron-down': !up,
      'fa-chevron-up': up,
    }"
  ></i>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["up"],
};
</script>